import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Document } from './Document'
import { useFetchDocuments } from './useFetchDocuments'

const ResidenceProofAndIncomeProof: FC<{
  applicationId: string
}> = ({ applicationId }) => {
  const { t } = useTranslation(['assignments'])
  const data = useFetchDocuments(applicationId)

  return (
    <>
      <p>
        <b>{t('card.loan-info.residential-document')} -</b>{' '}
        <Document state={data?.residenceProof} />
      </p>
      <p>
        <b>{t('card.loan-info.amount-document')} -</b>{' '}
        <Document state={data?.incomeProof} />
      </p>
    </>
  )
}

export { ResidenceProofAndIncomeProof }
